import(/* webpackMode: "eager" */ "/zaiyon/app/global-error.tsx");
